import { render, staticRenderFns } from "./DashboardLayoutVr.vue?vue&type=template&id=2670322f&"
import script from "./DashboardLayoutVr.vue?vue&type=script&lang=js&"
export * from "./DashboardLayoutVr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2670322f')) {
      api.createRecord('2670322f', component.options)
    } else {
      api.reload('2670322f', component.options)
    }
    module.hot.accept("./DashboardLayoutVr.vue?vue&type=template&id=2670322f&", function () {
      api.rerender('2670322f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Layout/DashboardLayoutVr.vue"
export default component.exports